<template>
  <div>
    <div class="black-overlay"></div>
  <div class="modal " id="maintenance_modal">
    <div class="modal__content">
      <button class="btn modal-close"><i class="icon-close"></i></button>
      <div class="modal__header modal_ti_header">
      </div>
      <div class="modal__body">
        <h1>{{ getTranslations.home_modals_game_maintenance_title }}</h1>
        <img class="modal_icon_alert" src="static/images/modals/maintenance.png" alt=""/>
        <p>{{ getTranslations.home_modals_game_maintenance_description_1 }}<br>{{ getTranslations.home_modals_game_maintenance_description_2 }}</p>
      </div>
      <!--div class="modal__footer">
        <a href="#" class="btn2 btn2--std btn2--small btn2--fixed">$#NEW GAME</a>
      </div-->
    </div>
  </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'game-maintenance',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/Maintenance.vue